import { MaterialReactTable } from "material-react-table"
import EditableTable from "./EditableTable"
import { defaultTableProps } from "./constants"
import React, { useCallback } from "react"
import { resourceBudgetType } from "../../../pages/ResourceBudget/types"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { assignUnit } from "./utils"
import { TableFooter } from "./Atom"
import { columns } from "./TableConfigs"
import { updateAppendedProvider } from "../../../redux/slices/resourceBudgetSlice"
import { permissions } from "../../../../config/constants"

type ResourcesBudgetTableProps = {
  onDeleteSuccess?: () => void
}

const ResourcesBudgetTable = ({ onDeleteSuccess }: ResourcesBudgetTableProps = {}) => {
  const dispatch = useAppDispatch()
  const { loading } = useAppSelector((state) => state.app)
  const state: resourceBudgetType = useAppSelector(
    (state) => state.resourceBudget,
  )
  const { dataIndex, data, aggregations } = state
  const published = (state as resourceBudgetType).published
  const { pinningCol, cols, additionalPinningCols } = columns[dataIndex]

  const enhancedColumns = React.useMemo(() => {
    return cols.map((col: any) => {
      if (col["accessorKey"] === pinningCol) {
        return {
          ...col,
          Footer: () => {
            return (
              <TableFooter
                col={col["accessorKey"]}
                renderValue={aggregations[dataIndex].data[col["accessorKey"]]}
              />
            )
          },
        }
      }
      return {
        ...col,
        Footer: () => {
          return (
            <TableFooter
              col={col["accessorKey"]}
              renderValue={assignUnit(
                aggregations[dataIndex].data,
                col["accessorKey"],
              )}
            />
          )
        },
      }
    })
  }, [cols, aggregations, dataIndex])

  const appendHandler = useCallback((data: any) => {
    dispatch(updateAppendedProvider(data))
  }, [])

  const allowed = useAppSelector((state) => {
    return state.rolesAndPerms.userPerms
  })
  console.log({ allowedPerms: allowed })

  const canCreate = React.useMemo(() => {
    return published
      ? allowed.includes(permissions.AFTER_PUBLISH_OPERATION)
      : allowed.includes(permissions.BEFORE_PUBLISH_OPERATION)
  }, [allowed, published])

  const canUpdate = React.useMemo(() => {
    return published
      ? allowed.includes(permissions.AFTER_PUBLISH_OPERATION)
      : allowed.includes(permissions.BEFORE_PUBLISH_OPERATION)
  }, [allowed, published])

  const canDelete = React.useMemo(() => {
    return published
      ? allowed.includes(permissions.AFTER_PUBLISH_OPERATION)
      : allowed.includes(permissions.BEFORE_PUBLISH_OPERATION)
  }, [allowed, published])

  const enableEditing = React.useMemo(() => {
    return !published || canCreate || canUpdate || canDelete
  }, [published, canCreate, canUpdate, canDelete])

  if (enableEditing) {
    return (
      <EditableTable
        key={`resource-editable-${dataIndex}`}
        state={state}
        loading={loading}
        appendHandler={appendHandler}
        onDeleteSuccess={onDeleteSuccess}
      />
    )
  }

  return (
    <MaterialReactTable
      columns={enhancedColumns}
      data={data}
      key={`saved-${dataIndex}`}
      {...defaultTableProps}
      initialState={{
        density: "compact",
      }}
      enableEditing={false}
      enableRowActions={false}
      state={{
        isLoading: loading,
        columnPinning: {
          left: [pinningCol, additionalPinningCols],
        },
      }}
    />
  )
}

export default ResourcesBudgetTable
